import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
  useParams,
} from "react-router-dom";
import Layout from "@/components/layout";
import {
  MenuCategoriesPageLazy,
  MenuItemsPageLazy,
  TestPageLazy,
  AboutUsPageLazy,
  SearchPageLazy,
  PageError404Lazy,
  PageError500Lazy,
} from "@/pages";
import ErrorFallback from "@/components/ui/errorFallback";
import SuspenseWrapper from "@/components/layoutWrapper/SuspenseWrapper";
import { getMenuTypeFromUrl } from "@/components/cart/helpers/cartEvents";

const CatchAllRedirect = () => {
  const { locale, menuId, branchId, typeMenu, ...rest } = useParams();
  const hasMenuId = Boolean(menuId);
  const menuTypeEnum = getMenuTypeFromUrl(typeMenu);
  if (!branchId || !menuTypeEnum) {
    const matchMenuId = rest["*"]?.match(/menu\/(\d+)/);
    const menuIdFromPath = matchMenuId ? matchMenuId[1] : null;
    return <Navigate to="/404" state={{ menuId: menuIdFromPath }} replace />;
  }
  const targetPath = hasMenuId
    ? locale
      ? `/${locale}/menu/${menuId}/${branchId}/${typeMenu}`
      : `/menu/${menuId}/${branchId}/${typeMenu}`
    : locale
      ? `/${locale}/me-qr/${branchId}/${typeMenu}`
      : `/me-qr/${branchId}/${typeMenu}`;
  return <Navigate to={targetPath} replace />;
};

const routes = (locale: string | undefined = "") => {
  const basePrefix = locale ? `/${locale}` : "";
  return [
    {
      path: basePrefix || "/",
      element: <Layout />,
      errorElement: <ErrorFallback />,
      children: [
        { path: "404", element: <PageError404Lazy /> },
        { path: "500", element: <PageError500Lazy /> },
        {
          path: "",
          element: <SuspenseWrapper />,
          children: [
            {
              path: "me-qr/:branchId/:typeMenu/:menuId",
              element: <MenuCategoriesPageLazy />,
            },
            {
              path: "menu/:menuId/:branchId/:typeMenu/categories/items",
              element: <MenuItemsPageLazy />,
            },
            {
              path: "menu/:menuId/:branchId/:typeMenu/about-us",
              element: <AboutUsPageLazy />,
            },
            {
              path: "menu/:menuId/:branchId/:typeMenu/search",
              element: <SearchPageLazy />,
            },
            {
              path: "me-qr/:branchId/:typeMenu",
              element: <MenuCategoriesPageLazy />,
            },
            {
              path: "me-qr/:branchId/:typeMenu/categories/items",
              element: <MenuItemsPageLazy />,
            },
            {
              path: "me-qr/:branchId/:typeMenu/about-us",
              element: <AboutUsPageLazy />,
            },
            {
              path: "me-qr/:branchId/:typeMenu/search",
              element: <SearchPageLazy />,
            },
            {
              path: "test",
              element: <TestPageLazy />,
            },
          ],
        },
        {
          path: "*",
          element: <CatchAllRedirect />,
        },
      ],
    },
  ];
};

const router = createBrowserRouter([...routes(), ...routes(":locale")]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
